export class SmartphotoDates {
    finished;
    constructor(finishedAtTimestamp) {
        this.finished = finishedAtTimestamp ? new Date(finishedAtTimestamp * 1000) : undefined;
    }
}
